import teamList from "./teamList.json";

function eloToWinRate(elo) {
	return 1/(1+Math.exp(-elo));
}

function teamPointerToTeam(teamPointer) {
	return teamList[teamPointer];
}

function teamToElo(team, leagueElo) {
	return team.elo;
}

function teamPointerToElo(teamPointer, leagueElo) {
	return teamToElo(teamPointerToTeam(teamPointer), leagueElo);
}

function gameToWinRate(game, leagueElo) {
	const team1Pointer = game.team1;
	const team2Pointer = game.team2;
	return eloToWinRate(teamPointerToElo(team1Pointer, leagueElo) - teamPointerToElo(team2Pointer, leagueElo));
}

export {eloToWinRate, teamPointerToTeam, teamToElo, teamPointerToElo, gameToWinRate};